import React from 'react'

const Tagline2 = () => (
  <div className="row tagline-2">
    <div className="col">
      <h3>
        Check out our <strong className="color-danger">amazing</strong> demos
      </h3>
      <p>
        Lots of layout and background color combinations in{' '}
        <strong>Delta</strong>.<br />These are just a few of them:
      </p>
    </div>
  </div>
)
export default Tagline2
